import styled from "styled-components";
import { breakpoint } from "@utilities";
import { AppModuleLayout } from "@layouts";

export const PointsLearnMore = () => {
    return (
        <AppModuleLayout>
            <StyledDiscount>
                <div className="discountWrapper">
                    <div className="discountContent">
                        <h2 className="heading">Learn More About Becoming a Rewards Member</h2>
                        <br />
                        <br />
                        <div className="discountSection">
                            <h3 className="subSectionHeading">What Is a Rewards Member?</h3>
                            <p className="contentText">
                                A Rewards Member account lets you <b>earn and redeem points</b> on
                                eligible bookings—whether for your own travel or for others. <br />
                                Once upgraded, you’ll see points and rewards tools throughout the
                                app instead of discount offers. You can use points at checkout to
                                reduce your payment total, and easily track your balance, recent
                                activity, and rewards history in one place.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">How Do I Upgrade? </h3>
                            <p className="contentText">
                                <li>Complete your profile.</li>
                                <br />
                                <li>
                                    Tap <b>Upgrade</b> on the home screen.
                                </li>
                                <br />
                                <li>
                                    Review the Rewards Member details and confirm in the pop-up.
                                </li>
                                <br />
                                Your account will instantly switch to Rewards Member status—starting
                                at 0 points.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">How Do Points Work?</h3>
                            <p className="contentText">
                                <li>
                                    <b>Earning Points:</b> Earn points when you complete eligible
                                    bookings (for yourself or for others).
                                </li>
                                <br />
                                <li>
                                    <b>Redeeming Points:</b> Apply points at checkout to reduce what
                                    you pay.
                                </li>
                                <br />
                                <li>
                                    <b>Order-Level Use:</b> Points apply to your{" "}
                                    <b>Payment total</b> , not to individual items.
                                </li>
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">Using Points at Checkout</h3>
                            <p className="contentText">
                                <li>
                                    If you have points available, you’ll see the{" "}
                                    <b>Use Reward Points</b>
                                    option.
                                </li>
                                <br />
                                <li>
                                    Use the slider to choose how many points to apply—up to your
                                    available balance or the order’s maximum limit.
                                </li>
                                <br />
                                <li>
                                    Your remaining balance to pay updates instantly as you move the
                                    slider.
                                </li>
                                <br />
                                <li>You can deselect the option anytime to remove points.</li>
                                <br />
                                <li>
                                    At time of checkout you can even Instant Claim the points from
                                    that booking now.
                                </li>
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">Where Can I See My Points?</h3>
                            <p className="contentText">
                                <li>
                                    <b>Home:</b> A banner shows your available and total points.
                                </li>
                                <br />
                                <li>
                                    <b>Points History:</b> See current balance, earned/spent/net
                                    points, and recent activity.
                                </li>
                                <br />
                                <li>
                                    <b>Cart, Quotes, and Checkout:</b> See total points available
                                    for your current order.
                                </li>
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">Important to Know</h3>
                            <p className="contentText">
                                <li>
                                    Points not claimed Instantly appear after travel is completed,
                                    not at the time of booking.
                                </li>
                                <br />
                                <li>The maximum you can redeem per order is shown at checkout.</li>
                                <br />
                                <li>Points expire 12 months after they’re credited.</li>
                                <br />
                                <li>
                                    If your booking changes or is refunded, points may be added back
                                    or deducted.
                                </li>
                                <br />
                                <li>
                                    Some products, fees, or promotions may be ineligible for earning
                                    or redeeming points.
                                </li>
                                <br />
                                <li>
                                    Points have no cash value and cannot be transferred or sold.
                                </li>
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">Pro Tips</h3>
                            <p className="contentText">
                                <li>
                                    Use the <b>Points Visibility Toggle</b> in My Account to hide
                                    your points balance from others.
                                </li>
                                <br />
                                <li>
                                    Check your Points History regularly to track earnings and
                                    spending.
                                </li>
                                <br />
                                <li>
                                    Plan big bookings to maximize your points and future rewards.
                                </li>
                            </p>
                        </div>
                    </div>
                </div>
            </StyledDiscount>
        </AppModuleLayout>
    );
};

const StyledDiscount = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: calc(100vh - 164px);
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    background: #fff;

    .discountWrapper {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: auto;
        max-width: 1200px;
        width: 100%;
        padding: 0px 24px;
        padding-bottom: 50px;
    }
    .discountSection {
        margin-top: 20px;
    }

    .discountContent {
        width: 100%;
        max-width: 1200px;
    }

    .heading {
        font-size: 24px;
        font-weight: 600;
        line-height: 120%;
        color: ${(props) => props.theme.colors.black};
        margin: 0;
        text-align: left;
    }

    .subSectionHeading {
        font-size: 18px;
        font-weight: 600;
        line-height: 120%;
        color: #131214;
        margin: 16px 0 8px 0;
    }

    .contentText {
        margin: 0 0 16px 0;
    }

    ${breakpoint.breakMobileMedium`
        .discountContent {
            padding: 24px;
            font-size: 16px;
            font-weight: 400;

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: rgba(0, 0, 0, .3);
                border-radius: 5px;
            }
        }
    `}

    @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
        .heading {
            font-size: 24px;
        }
        .subHeading,
        .discountContent,
        .subSectionHeading {
            font-size: 16px;
        }
    }
`;
